import React, { useState, useEffect, useRef, useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import {
	MdCheckBox,
	MdCheckBoxOutlineBlank,
	MdOutlineCheckBox,
	MdOutlineCheckBoxOutlineBlank,
	MdOutlineFileUpload,
} from 'react-icons/md'

import { FiPlus } from 'react-icons/fi'
import { IoMdClose } from 'react-icons/io'
import { FaCircleCheck } from 'react-icons/fa6'

import styles from './settings.module.css'
import {
	languages,
	countries,
	dateFormats,
	hourFormats,
	durations,
	timezones,
	guestPermissions,
	startWeek,
	customViews,
} from './utils/constants'
import CustomDropDown from './components/CustomDropDown'
import CheckboxAndText from './components/CheckboxAndText'
import CustomToast from './components/CustomToast'

import CustomInput from './components/CustomInput'
import { updateCalendar, createCalendar, getUserCalendars } from '@src/actions/calendar'
import ShareCalendar from './components/ShareCalendar'

import { CalendarContext } from '../CalendarContext'
import WorkingHoursSettings from './components/WorkingHoursSettings'
import SetStartEndDatePopup from './components/SetStartEndDatePopup'
import NormalDropdown from './components/NormalDropdown'

import { generateDayHours } from './utils'

const Settings = () => {

	const navigate = useNavigate()
	const dispatch = useDispatch()
	const { user } = useSelector((state) => state.user)
	const {
		selectedCalendarData,

		selectedCalendar,
		userCalendars,
	} = useSelector((state) => state.calendar)

	const {
		generateInvitationId,
		handleShowToast,
		toastMessage,
		showToast,
		setShowToast,
		setHourFormat,
		getRandomColor,
	} = useContext(CalendarContext)

	const [showPeoplePopUp, setShowPeoplePopUp] = useState(false)
	const [searchPeople, setSearchPeople] = useState('')
	const [selectedLanguage, setSelectedLanguage] = useState(
		selectedCalendarData.language
	)
	const [selectedCountry, setSelectedCountry] = useState(
		selectedCalendarData.country
	)
	const [selectedHourFormat, setSelectedHourFormat] = useState(
		selectedCalendarData.hourFormat
	)
	const [selectedDateFormat, setSelectedDateFormat] = useState(
		selectedCalendarData.dateFormat
	)

	const [customView, setCustomView] = useState(selectedCalendarData.defaultView)
	const [weekStartsAt, setWeekStartsAt] = useState(
		selectedCalendarData.weekStartsAt
	)
	const [selectedGuestsPermissions, setSelectedGuestsPermissions] = useState(
		selectedCalendarData.guestPermissions
	)
	const [selectedDuration, setSelectedDuration] = useState(
		`${selectedCalendarData.eventsDuration} minutos`
	)

	const [calendarName, setCalendarName] = useState(
		selectedCalendarData.calendarName
	)
	const [description, setDescription] = useState(
		selectedCalendarData.description
	)
	const [selectedTimeZone, setSelectedTimeZone] = useState(
		selectedCalendarData.timezone
	)
	const [availableNow, setAvailableNow] = useState(
		selectedCalendarData.availableNow || true
	)
	const [appointmentsStartEndDate, setAppointmentsStartEndDate] = useState(
		selectedCalendarData.appointmentsStartEndDate || false
	)
	const [minTimeBeforeSchedule, setMinTimeBeforeSchedule] = useState(
		selectedCalendarData.minTimeBeforeSchedule || false
	)
	const [maxTimeBeforeSchedule, setMaxTimeBeforeSchedule] = useState(
		selectedCalendarData.maxTimeBeforeSchedule || false
	)

	const [newCalendarName, setNewCalendarName] = useState('')
	const [newCalendarDescription, setNewCalendarDescription] = useState('')
	const [newCalendarSelectedTimeZone, setNewCalendarSelectedTimeZone] =
		useState('(GMT+01:00) España - Madrid')

	const [showStartEndDatePopup, setShowStartEndDatePopup] = useState(false)
	const [canScheduleFrom, setCanScheduleFrom] = useState(
		selectedCalendarData.canScheduleFrom || false
	)
	const [canScheduleUpTo, setCanScheduleUpTo] = useState(
		selectedCalendarData.canScheduleUpTo || false
	)
	const [selectedSettings, setSelectedSettings] = useState()
	
	
	
	const [showSecondaryTimezone, setShowSecondaryTimezone] = useState(
		selectedCalendarData.showSecondaryTimezone
	)
	const [
		changeMainTimezoneForLocationOne,
		setChangeMainTimezoneForLocationOne,
	] = useState(selectedCalendarData.askToChangeTimezone)
	const [fastMeetings, setFastMeetings] = useState(
		selectedCalendarData.fastMeetings
	)
	const [showWeekends, setShowWeekends] = useState(
		selectedCalendarData.showWeekends
	)
	const [showDeclinedEvents, setShowDeclinedEvents] = useState(
		selectedCalendarData.showDeniedEvents
	)
	const [showCompletedTasks, setShowCompletedTasks] = useState(
		selectedCalendarData.showFinishedTasks
	)
	const [showWeekNumbers, setShowWeekNumbers] = useState(
		selectedCalendarData.showWeekNumber
	)
	const [shorterEvents, setShorterEvents] = useState(
		selectedCalendarData.showShorterEventsAs30
	)
	const [reduceBrightness, setReduceBrightness] = useState(
		selectedCalendarData.lowerPastEventsBrightness
	)
	const [viewSideBySideCalendars, setViewSideBySideCalendars] = useState(
		selectedCalendarData.enableSideBySide
	)
	const [automaticallyShowAythenEvents, setAutomaticallyShowAythenEvents] =
		useState(selectedCalendarData.showEventsCreatedByAythen)
	const [enableWorkingHours, setEnableWorkingHours] = useState(
		selectedCalendarData.enableWorkSchedule
	)
	const [
		appointmentsCalendarInsteadOfAvailableHours,
		setAppointmentsCalendarInsteadOfAvailableHours,
	] = useState(
		selectedCalendarData.createAppointmentsCalendarInsteadOfAvailableHours
	)
	const [calendarAsPublic, setCalendarAsPublic] = useState(
		selectedCalendarData.publicCalendar
	)
	const [shareWithEveryOne, setShareWithEveryOne] = useState(
		selectedCalendarData.publicSharing
	)
	const [shareWithAythen, setShareWithAythen] = useState(
		selectedCalendarData.shareWithAythen
	)
	const [dailyEventsNotification, setDailyEventsNotification] = useState(
		selectedCalendarData.dailyEventsNotification
	)
	const [
		showCalendarDataInOtherAythenApps,
		setShowCalendarDataInOtherAythenApps,
	] = useState(selectedCalendarData.showCalendarInfoOnOtherAythenApps)

	const [visibleId, setVisibleId] = useState(null)
	const [isSelected, setIsSelected] = useState(null)
	const [isUserSelecting, setIsUserSelecting] = useState(false)

	const [calendarToDelete, setCalendarToDelete] = useState()
	const [calendarToMergeWith, setCalendarToMergeWith] = useState(
		selectedCalendarData.calendarName
	)
	const [selectedCalendarsToExport, setSelectedCalendarsToExport] = useState([])
	const [calendarEventsToImport, setCalendarEventsToImport] = useState()

	const [calendarNotifications, setCalendarNotifications] = useState(
		selectedCalendarData.calendarNotifications
	)

	const [isSent, setIsSent] = useState(false)


	const [notifications, setNotifications] = useState([
		{
			id: Date.now(),
			type: 'Notificación',
			timeValue: 10,
			timeType: 'minutos',
		},
	])



	const hoursOptions = generateDayHours(
		6,
		22,
		selectedCalendarData.eventsDuration
	)
	
	const ids0 = [
		'language',
		'zone',
		'event',
		'notification',
		'view',
		'events',
		'workTime',
		'interval',
	]
	const ids1 = ['add-calendar']
	const ids2 = [
		'settings',
		'access',
		'share',
		'event-notification',
		'event-more',
		'meet',
		'from-url',
		'delete',
	]
	const ids3 = ['import', 'export']

	const containerRef = useRef(null)
	const ids = [...ids0, ...ids1, ...ids2, ...ids3]
	const sets = [
		...Array(ids0.length).fill('ids0'),
		...Array(ids1.length).fill('ids1'),
		...Array(ids2.length).fill('ids2'),
		...Array(ids3.length).fill('ids3'),
	]

	

	const handleSaveStartEndDate = (
		start,
		selectedStartDate,
		end,
		selectedEndDate
	) => {
		setSelectedSettings({
			start,
			selectedStartDate,
			end,
			selectedEndDate,
		})

		setShowStartEndDatePopup(false)

	}


	const handleSaveScheduleGapSettings = () => {

		dispatch(
			updateCalendar({
				userId: user.id,
				calendarId: selectedCalendar,
				toUpdate: { availableNow },
			})
		)
		dispatch(
			updateCalendar({
				userId: user.id,
				calendarId: selectedCalendar,
				toUpdate: { appointmentsStartEndDate },
			})
		)
		dispatch(
			updateCalendar({
				userId: user.id,
				calendarId: selectedCalendar,
				toUpdate: { minTimeBeforeSchedule },
			})
		)
		dispatch(
			updateCalendar({
				userId: user.id,
				calendarId: selectedCalendar,
				toUpdate: { maxTimeBeforeSchedule },
			})
		).finally(() => handleShowToast('Configuración guardada!'))
	}

	const handleMinTimeBeforeSchedule = () => {
		if (minTimeBeforeSchedule) {
			setMinTimeBeforeSchedule(0)
			dispatch(
				updateCalendar({
					userId: user.id,
					calendarId: selectedCalendar,
					toUpdate: { minTimeBeforeSchedule: false },
				})
			).finally(() => handleShowToast('Configuración guardada!'))
		} else {
			setMinTimeBeforeSchedule(4)
		}
	}

	const handleMaxTimeBeforeSchedule = () => {
		if (maxTimeBeforeSchedule) {
			setMaxTimeBeforeSchedule(0)
			dispatch(
				updateCalendar({
					userId: user.id,
					calendarId: selectedCalendar,
					toUpdate: { maxTimeBeforeSchedule: false },
				})
			).finally(() => handleShowToast('Configuración guardada!'))
		} else {
			setMaxTimeBeforeSchedule(60)
		}
	}

	const addNotification = () => {
		setNotifications((prev) => [
			...prev,
			{
				id: Date.now(),
				type: 'Notificación',
				timeValue: 10,
				timeType: 'minutos',
			},
		])
	}

	const updateNotification = (id, field, value) => {
		setNotifications((prev) =>
			prev.map((notification) =>
				notification.id === id
					? { ...notification, [field]: value }
					: notification
			)
		)
	}

	const removeNotification = (id) => {
		setNotifications((prev) =>
			prev.filter((notification) => notification.id !== id)
		)
	}


	const handleFileUpload = (event) => {
		const file = event.target.files[0]
		if (file) {
			const reader = new FileReader()
			reader.onload = (e) => {
				try {
					const jsonData = JSON.parse(e.target.result)
					setCalendarEventsToImport(jsonData)
				} catch (error) {
					console.error('Error parsing JSON file:', error)
				}
			}
			reader.readAsText(file)
		}
	}

	const handleExportCalendars = () => {
		if (selectedCalendarsToExport.length > 0) {
			const calendarEventsToExport = selectedCalendarsToExport
				.map((calendar) => [...calendar.events, ...calendar.importedEvents])
				.flat()
				.filter(
					(obj, index, self) => index === self.findIndex((o) => o.id === obj.id)
				)

			const calendarEventsIdsToExport = calendarEventsToExport.map(
				(ev) => ev.id
			)

			const jsonData = JSON.stringify(calendarEventsIdsToExport)
			const blob = new Blob([jsonData], { type: 'application/json' })
			const url = URL.createObjectURL(blob)
			const link = document.createElement('a')
			link.href = url
			link.download = 'calendarEventsIds.json'
			link.click()
			URL.revokeObjectURL(url)

			handleShowToast(
				`${selectedCalendarsToExport.length > 1 ? 'Calendarios exportados' : 'Calendario exportado'} exitosamente!`
			)
		} else {
			console.error('Pls select a calendar!')
		}
	}

	const handleDeleteCalendarEvents = () => {
		if (calendarToDelete) {
			handleShowToast(
				`Eventos del calendario ${calendarToDelete} eliminados exitosamente!`
			)
		} else {
			console.error('Pls select a calendar!')
		}
	}

	const handleImportCalendar = () => {
		if (calendarToMergeWith) {
			const actualImportedEvents = [
				...selectedCalendarData.importedEvents,
				...calendarEventsToImport,
			]

			const finalImportedEvents = [...new Set(actualImportedEvents)].filter(
				(eventId) =>
					!selectedCalendarData.events.some((ev) => ev.id === eventId)
			)
			dispatch(
				updateCalendar({
					userId: user.id,
					calendarId: selectedCalendar,
					toUpdate: { importedEvents: finalImportedEvents },
				})
			).finally(() =>
				handleShowToast(
					`${calendarEventsToImport.length > 1 ? 'Eventos importados' : 'Evento importado'} exitosamente!`
				)
			)
		} else {
			console.error('Pls select a calendar!')
		}
	}

	const handleCreateCalendar = () => {
		if (newCalendarName.trim() === '') {
			alert('Please enter a calendar name.')
			return
		}

		const newCalendar = {
			userId: user.id,
			calendarData: {
				owner: user.user,
				calendarName: newCalendarName,
				description: newCalendarDescription,
				timezone: newCalendarSelectedTimeZone,
				language: 'Español',
				country: 'España',
				dateFormat: '31/12/2024',
				hourFormat: '1:00am',
				participants: [],
				showSecondayTimezone: false,
				askToChangeTimezone: false,
				importedEvents: [],
				eventsDuration: 30,
				fastMeetings: false,
				guestPermissions: 'Ver lista de invitados',
				showWeekends: true,
				showDeniedEvents: false,
				shareId: generateInvitationId(),
				participants: [],
				showFinishedTasks: true,
				workingHoursSettings: {},
				showWeekNumber: true,
				showShorterEventsAs30: false,
				lowerPastEventsBrightness: true,
				weekStartsAt: 'Lunes',
				defaultView: '2 días',
				showEventsCreatedByAythen: true,
				emailEventsPrivacy: 'Calendario por defecto',
				enableWorkSchedule: false,
				createAppointmentsCalendarInsteadOfAvailableHours: false,
				publicCalendar: false,
				publicSharing: false,
				shareWithAythen: true,
				showCalendarInfoOnOtherAythenApps: true,
				enableSideBySide: false,
				attachedTasks: [],
				events: [],
				calendarColor: getRandomColor(),
				calendarEventsReminder: 10,
				calendarNotifications: {
					newEvents: false,
					modifiedEvents: false,
					canceledEvents: false,
					invitationsAnswers: false,
					dailySchedule: false, 
				},
				previewSettings: {
					showTitle: true,
					showNavButtons: true,
					showDate: true,
					showPrint: true,
					showTabs: true,
					showCalendarsList: true,
					showTimezone: true,
					backgroundColor: 'default',
					border: true,
					defaultCalendar: 'Mes',
					weekStarts: 'Lunes',
					timezone: 'default',
					language: 'default',
				},
			},
		}

		dispatch(createCalendar(newCalendar))
			.then(() => dispatch(getUserCalendars({ userId: user.id })))
			.finally(() => handleShowToast('Calendario creado!'))
	}

	const handleUpdateActualCalendar = () => {
		if (description.length > 0 || calendarName.length > 0 || selectedTimeZone) {
			dispatch(
				updateCalendar({
					userId: user.id,
					calendarId: selectedCalendar,
					toUpdate: { description, calendarName, timezone: selectedTimeZone },
				})
			).finally(() => handleShowToast('Configuración guardada!'))
		}
	}

	const updateCalendarProperty = (setState, newValue, backendProp) => {
		let actualNewValue = newValue
		if (backendProp === 'dailyEventsNotification' && newValue !== false) {
			actualNewValue = '8:00 AM'
		}
		setState(actualNewValue)

		if (backendProp === 'eventsDuration') {
			actualNewValue = parseInt(newValue.split(' ')[0])
		}

		dispatch(
			updateCalendar({
				userId: user.id,
				calendarId: selectedCalendar,
				toUpdate: { [backendProp]: actualNewValue },
			})
		).finally(() => handleShowToast())
	}


	const useVisibleElement = (
		containerRef,
		ids,
		sets,
		isUserSelecting,
		setIsUserSelecting
	) => {
		useEffect(() => {
			const handleScroll = () => {
				if (isUserSelecting) return

				const container = containerRef.current
				if (!container) return

				let closestElementId = null
				let closestDistance = Number.POSITIVE_INFINITY

				ids.forEach((id) => {
					const element = document.getElementById(id)
					if (element) {
						const elementTop =
							element.getBoundingClientRect().top -
							container.getBoundingClientRect().top

						const threshold = 100

						if (elementTop >= -threshold && elementTop < closestDistance) {
							closestDistance = elementTop
							closestElementId = id
						}
					}
				})

				if (closestElementId) {
					const setIndex = ids.indexOf(closestElementId)
					setVisibleId(sets[setIndex])
					setIsSelected(closestElementId)
				}
			}

			const container = containerRef.current
			if (container) {
				container.addEventListener('scroll', handleScroll)
				handleScroll()
			}

			return () => {
				if (container) {
					container.removeEventListener('scroll', handleScroll)
				}
			}
		}, [containerRef, ids, sets, isUserSelecting])
	}

	

	useVisibleElement(
		containerRef,
		ids,
		sets,
		isUserSelecting,
		setIsUserSelecting
	)


	useEffect(() => {
		if (selectedSettings) {
			setAvailableNow(false)
			dispatch(
				updateCalendar({
					userId: user.id,
					calendarId: selectedCalendar,
					toUpdate: { availableNow: false },
				})
			)
		} else {
			setAvailableNow(true)
			dispatch(
				updateCalendar({
					userId: user.id,
					calendarId: selectedCalendar,
					toUpdate: { availableNow: true },
				})
			)
		}
	}, [selectedSettings])

	useEffect(() => {
		if (availableNow === true) {
			setAppointmentsStartEndDate(false)
			setSelectedSettings()
			setCanScheduleFrom()
			setCanScheduleUpTo()

			dispatch(
				updateCalendar({
					userId: user.id,
					calendarId: selectedCalendar,
					toUpdate: { appointmentsStartEndDate: false },
				})
			)
		}
	}, [availableNow])
	
	useEffect(() => {
		if (calendarNotifications.newEvents) {
			setIsSent(true)
		}
	}, [calendarNotifications])
	
	useEffect(() => {
		if (isSelected && isUserSelecting) {
			const element = document.getElementById(isSelected)
			if (element) {
				element.scrollIntoView({ behavior: 'smooth', block: 'start' })
			}
		}
		if (isUserSelecting) {
			setTimeout(() => setIsUserSelecting(false), 500)
		}
	}, [isSelected])


	return (
		<div className={styles.settings}>
			{showStartEndDatePopup && (
				<SetStartEndDatePopup
					start={canScheduleFrom}
					setStart={setCanScheduleFrom}
					end={canScheduleUpTo}
					setEnd={setCanScheduleUpTo}
					title={'Fechas de inicio y finalización de la ventana de la agenda'}
					onClose={() => setShowStartEndDatePopup(false)}
					onSave={handleSaveStartEndDate}
				/>
			)}
			<CustomToast
				message={toastMessage}
				showToast={showToast}
				setShowToast={setShowToast}
			/>
			<div className={styles.left}>
				<ul>
					<li
						className={visibleId == 'ids0' ? styles.active : ''}
						onClick={() => {
							setIsUserSelecting(true)
							setIsSelected('language')
						}}
					>
						General
						<svg fill='none' viewBox='0 0 24 24'>
							<path
								stroke='currentColor'
								strokeLinecap='round'
								strokeLinejoin='round'
								strokeWidth='2'
								d='m16 14-4-4-4 4'
							/>
						</svg>
					</li>
					<ud>
						<ld
							className={isSelected == 'language' ? styles.active : ''}
							onClick={() => {
								setIsUserSelecting(true)
								setIsSelected('language')
							}}
						>
							Idioma y región
						</ld>
						<ld
							className={isSelected == 'zone' ? styles.active : ''}
							onClick={() => {
								setIsUserSelecting(true)
								setIsSelected('zone')
							}}
						>
							Zona horaria
						</ld>
						<ld
							className={isSelected == 'event' ? styles.active : ''}
							onClick={() => {
								setIsUserSelecting(true)
								setIsSelected('event')
							}}
						>
							Ajustes de eventos
						</ld>
						<ld
							className={isSelected == 'view' ? styles.active : ''}
							onClick={() => {
								setIsUserSelecting(true)
								setIsSelected('view')
							}}
						>
							Opciones de visualización
						</ld>
						<ld
							className={isSelected == 'events' ? styles.active : ''}
							onClick={() => {
								setIsUserSelecting(true)
								setIsSelected('events')
							}}
						>
							Eventos de FacturaGPT
						</ld>
						<ld
							className={isSelected == 'workTime' ? styles.active : ''}
							onClick={() => {
								setIsUserSelecting(true)
								setIsSelected('workTime')
							}}
						>
							Horario y ubicación
						</ld>
						<ld
							className={isSelected == 'interval' ? styles.active : ''}
							onClick={() => {
								setIsUserSelecting(true)
								setIsSelected('interval')
							}}
						>
							Franja de programación
						</ld>
					</ud>
				</ul>
				<ul>
					<li
						className={visibleId == 'ids1' ? styles.active : ''}
						onClick={() => {
							setIsUserSelecting(true)
							setIsSelected('suscribe')
						}}
					>
						Añadir calendario
						<svg fill='none' viewBox='0 0 24 24'>
							<path
								stroke='currentColor'
								strokeLinecap='round'
								strokeLinejoin='round'
								strokeWidth='2'
								d='m16 14-4-4-4 4'
							/>
						</svg>
					</li>
					<ud>
						<ld
							className={isSelected == 'suscribe' ? styles.active : ''}
							onClick={() => {
								setIsUserSelecting(true)
								setIsSelected('suscribe')
							}}
						>
							Subscribirse
						</ld>
						<ld
							className={isSelected == 'add-calendar' ? styles.active : ''}
							onClick={() => {
								setIsUserSelecting(true)
								setIsSelected('add-calendar')
							}}
						>
							Crear un calendario
						</ld>
					</ud>
				</ul>

				<ul>
					<li
						className={visibleId == 'ids2' ? styles.active : ''}
						onClick={() => {
							setIsUserSelecting(true)
							setIsSelected('settings')
						}}
					>
						Configuración de Calendar
						<svg fill='none' viewBox='0 0 24 24'>
							<path
								stroke='currentColor'
								strokeLinecap='round'
								strokeLinejoin='round'
								strokeWidth='2'
								d='m16 14-4-4-4 4'
							/>
						</svg>
					</li>
					<ud>
						<ld
							className={isSelected == 'settings' ? styles.active : ''}
							onClick={() => {
								setIsUserSelecting(true)
								setIsSelected('settings')
							}}
						>
							Configuración de Calendar
						</ld>
						<ld
							className={isSelected == 'access' ? styles.active : ''}
							onClick={() => {
								setIsUserSelecting(true)
								setIsSelected('access')
							}}
						>
							Permisos de acceso a los eventos
						</ld>
						<ld
							className={isSelected == 'share' ? styles.active : ''}
							onClick={() => {
								setIsUserSelecting(true)
								setIsSelected('share')
							}}
						>
							Compartir con personas o grupos
						</ld>
						<ld
							className={
								isSelected == 'event-notification' ? styles.active : ''
							}
							onClick={() => {
								setIsUserSelecting(true)
								setIsSelected('event-notification')
							}}
						>
							Notificaciones de eventos
						</ld>
						<ld
							className={isSelected == 'event-more' ? styles.active : ''}
							onClick={() => {
								setIsUserSelecting(true)
								setIsSelected('event-more')
							}}
						>
							Otras notificaciones
						</ld>
						<ld
							className={isSelected == 'meet' ? styles.active : ''}
							onClick={() => {
								setIsUserSelecting(true)
								setIsSelected('meet')
							}}
						>
							Calendario de citas
						</ld>
						<ld
							className={isSelected == 'from-url' ? styles.active : ''}
							onClick={() => {
								setIsUserSelecting(true)
								setIsSelected('from-url')
							}}
						>
							Desde URL
						</ld>
						<ld
							className={isSelected == 'delete' ? styles.active : ''}
							onClick={() => {
								setIsUserSelecting(true)
								setIsSelected('delete')
							}}
						>
							Eliminar calendario
						</ld>
					</ud>
				</ul>
				<ul>
					<li
						className={visibleId == 'ids3' ? styles.active : ''}
						onClick={() => {
							setIsUserSelecting(true)
							setIsSelected('import')
						}}
					>
						Importar y Exportar
						<svg fill='none' viewBox='0 0 24 24'>
							<path
								stroke='currentColor'
								strokeLinecap='round'
								strokeLinejoin='round'
								strokeWidth='2'
								d='m16 14-4-4-4 4'
							/>
						</svg>
					</li>
					<ud>
						<ld
							className={isSelected == 'import' ? styles.active : ''}
							onClick={() => {
								setIsUserSelecting(true)
								setIsSelected('import')
							}}
						>
							Importar
						</ld>
						<ld
							className={isSelected == 'export' ? styles.active : ''}
							onClick={() => {
								setIsUserSelecting(true)
								setIsSelected('export')
							}}
						>
							Exportar
						</ld>
					</ud>
				</ul>
			</div>
			<div ref={containerRef} className={styles.right}>
				<div className={styles.container}>
					<div id='language' className={styles.content}>
						<b className={styles.title}>Idioma y región</b>
						<CustomDropDown
							title='Idioma'
							placeholder='Selecciona un idioma'
							options={languages}
							backProp={'language'}
							updateCalendarProperty={updateCalendarProperty}
							selectedOption={selectedLanguage}
							setSelectedOption={setSelectedLanguage}
						/>
						<CustomDropDown
							title='Pais'
							placeholder='Selecciona un pais'
							options={countries}
							backProp={'country'}
							updateCalendarProperty={updateCalendarProperty}
							selectedOption={selectedCountry}
							setSelectedOption={setSelectedCountry}
						/>
						<CustomDropDown
							title='Formato de fecha'
							placeholder='Selecciona un formato de fecha'
							options={dateFormats}
							backProp={'dateFormat'}
							updateCalendarProperty={updateCalendarProperty}
							selectedOption={selectedDateFormat}
							setSelectedOption={setSelectedDateFormat}
						/>
						<CustomDropDown
							title='Formato de hora'
							placeholder='Selecciona un formato de hora'
							options={hourFormats}
							backProp={'hourFormat'}
							updateCalendarProperty={updateCalendarProperty}
							selectedOption={selectedHourFormat}
							setSelectedOption={(option) => {
								setSelectedHourFormat(option)
								setHourFormat(option)
							}}
						/>
					</div>

					<div id='zone' className={styles.content}>
						<b className={styles.title}>Zona horaria</b>

						<CheckboxAndText
							text={'Mostrar zona horaria secundaria'}
							state={showSecondaryTimezone}
							backProp={'showSecondayTimezone'}
							updateCalendarProperty={updateCalendarProperty}
							setState={setShowSecondaryTimezone}
						/>
						<CheckboxAndText
							text={
								'Preguntarme si quiero cambiar mi zona horaria principal por la de mi ubicación actual'
							}
							backProp={'askToChangeTimezone'}
							state={changeMainTimezoneForLocationOne}
							updateCalendarProperty={updateCalendarProperty}
							setState={setChangeMainTimezoneForLocationOne}
						/>

						<p className={styles.small}>
							{`Más información sobre cómo funciona Google Calendar entre
							distintas `}
							<a style={{ cursor: 'pointer', userSelect: 'none' }}>
								zonas horarias
							</a>
						</p>
					</div>

					<div id='event' className={styles.content}>
						<b className={styles.title}>Ajustes de eventos</b>
						<CustomDropDown
							title='Duración predeterminada'
							placeholder='Selecciona una duración predeterminada'
							options={durations}
							backProp={'eventsDuration'}
							updateCalendarProperty={updateCalendarProperty}
							selectedOption={selectedDuration}
							setSelectedOption={setSelectedDuration}
						/>
						<CheckboxAndText
							text={'Reuniones rápidas'}
							state={fastMeetings}
							backProp={'fastMeetings'}
							updateCalendarProperty={updateCalendarProperty}
							setState={setFastMeetings}
						/>
						<small>
							Finalizar 5 minutos antes de media hora y 10 minutos antes las más
							largas
						</small>
					</div>

					<div id='notification' className={styles.content}>
						<CustomDropDown
							title='Permisos de invitados predeterminados'
							placeholder='Selecciona permisos de los invitados'
							options={guestPermissions}
							backProp={'guestPermissions'}
							updateCalendarProperty={updateCalendarProperty}
							selectedOption={selectedGuestsPermissions}
							setSelectedOption={setSelectedGuestsPermissions}
						/>
					</div>

					<div id='view' className={styles.content}>
						<b className={styles.title}>Opciones de visualización</b>
						<CheckboxAndText
							text={'Mostrar fines de semana'}
							state={showWeekends}
							backProp={'showWeekends'}
							updateCalendarProperty={updateCalendarProperty}
							setState={setShowWeekends}
						/>
						<CheckboxAndText
							text={'Mostrar eventos rechazados'}
							state={showDeclinedEvents}
							backProp={'showDeniedEvents'}
							updateCalendarProperty={updateCalendarProperty}
							setState={setShowDeclinedEvents}
						/>
						<CheckboxAndText
							text={'Mostrar tareas completadas'}
							state={showCompletedTasks}
							backProp={'showFinishedTasks'}
							updateCalendarProperty={updateCalendarProperty}
							setState={setShowCompletedTasks}
						/>
						<CheckboxAndText
							text={'Mostrar números de semana'}
							state={showWeekNumbers}
							backProp={'showWeekNumber'}
							updateCalendarProperty={updateCalendarProperty}
							setState={setShowWeekNumbers}
						/>
						<CheckboxAndText
							text={'Mostrar los eventos más cortos como eventos de 30 minutos'}
							state={shorterEvents}
							backProp={'showShorterEventsAs30'}
							updateCalendarProperty={updateCalendarProperty}
							setState={setShorterEvents}
						/>
						<CheckboxAndText
							text={'Reducir el brillo de eventos pasados'}
							state={reduceBrightness}
							backProp={'lowerPastEventsBrightness'}
							updateCalendarProperty={updateCalendarProperty}
							setState={setReduceBrightness}
						/>
						<CheckboxAndText
							text={'Ver calendarios en paralelo en la vista del dia'}
							state={viewSideBySideCalendars}
							backProp={'enableSideBySide'}
							updateCalendarProperty={updateCalendarProperty}
							setState={setViewSideBySideCalendars}
						/>
						<CustomDropDown
							title='La semana empieza el'
							placeholder='Selecciona el dia en el que la semana empieza'
							options={startWeek}
							backProp={'weekStartsAt'}
							updateCalendarProperty={updateCalendarProperty}
							selectedOption={weekStartsAt}
							setSelectedOption={setWeekStartsAt}
						/>
						<CustomDropDown
							title='Establecer vista personalizada'
							placeholder='Selecciona vista personalizada'
							options={customViews}
							backProp={'defaultView'}
							selectedOption={customView}
							updateCalendarProperty={updateCalendarProperty}
							setSelectedOption={setCustomView}
						/>
					</div>

					<div id='events' className={styles.content}>
						<b className={styles.title}>Eventos de FacturaGPT</b>
						<p>
							Athen puede crear automáticamente eventos y mostrarlos en tu
							calendario. Estos eventos te ayudan a hacer un seguimiento de
							vuelos u otras reservas.
						</p>
						<CheckboxAndText
							text={
								'Mostrar mi calendario los eventos creados automáticamente por FacturaGPT'
							}
							backProp={'showEventsCreatedByAythen'}
							updateCalendarProperty={updateCalendarProperty}
							state={automaticallyShowAythenEvents}
							setState={setAutomaticallyShowAythenEvents}
						/>
						<p className={styles.small}>
							{`Para recibir eventos de Gmail, tienes que activar también
							Funciones inteligentes y personalización en los ajustes de Gmail. `}
							<a
								style={{ cursor: 'pointer' }}
								onClick={() => navigate('/help')}
							>
								Más información
							</a>
						</p>
					</div>

					<div id='workTime' className={styles.content}>
						<b className={styles.title}>Horario laboral y ubicación</b>
						<b>Activar horario laboral</b>
						<CheckboxAndText
							text={
								'Si habilitas el horario laboral, los demás usuarios recibirán un aviso si intentan invitarte una reunión fuera de este horario'
							}
							backProp={'enableWorkSchedule'}
							state={enableWorkingHours}
							updateCalendarProperty={updateCalendarProperty}
							setState={setEnableWorkingHours}
						/>
						<WorkingHoursSettings
							handleShowToast={handleShowToast}
							workingHourEnabled={enableWorkingHours}
						/>

					</div>

					<div id='interval' className={styles.content}>
						<b className={styles.title}>Franja de programación</b>
						<p className={styles.subtitle}>
							Limita el intervalo de tiempo en la que se pueden reservar
							reuniones.
						</p>

						<CheckboxAndText
							text={'Ya disponible'}
							state={availableNow}
							setState={setAvailableNow}
							backProp={'availableNow'}
							updateCalendarProperty={updateCalendarProperty}
						/>

						<CheckboxAndText
							text={'Fechas de inicio y finalización'}
							subtitle={'Limita el intervalo de fechas en todas las reuniones'}
							state={selectedSettings}
							setState={setShowStartEndDatePopup}
						/>

						<p className={styles.subtitle}>
							Tiempo máximo antes de la reunion con el que se puede reservar.
						</p>

						<div className={styles.checkboxWithInputContainer}>
							<button
								className={
									maxTimeBeforeSchedule
										? styles.checkedButton
										: styles.uncheckedButton
								}
								style={{ cursor: 'pointer' }}
								onClick={handleMaxTimeBeforeSchedule}
							>
								{maxTimeBeforeSchedule ? (
									<MdOutlineCheckBox
										size={20}
										className={styles.checkboxIcon}
									/>
								) : (
									<MdOutlineCheckBoxOutlineBlank
										size={20}
										className={styles.checkboxIcon}
									/>
								)}
							</button>
							<input
								className={styles.numberInputCheckbox}
								value={maxTimeBeforeSchedule}
								type='number'
								min={0}
								placeholder='60'
								onChange={(e) => setMaxTimeBeforeSchedule(e.target.value)}
							/>
							<span>días</span>
						</div>
						<p className={styles.subtitle}>
							Tiempo máximo antes de la cita con el que se puede reservar.
						</p>

						<div className={styles.checkboxWithInputContainer}>
							<button
								className={
									minTimeBeforeSchedule
										? styles.checkedButton
										: styles.uncheckedButton
								}
								style={{ cursor: 'pointer' }}
								onClick={handleMinTimeBeforeSchedule}
							>
								{minTimeBeforeSchedule ? (
									<MdOutlineCheckBox
										size={20}
										className={styles.checkboxIcon}
									/>
								) : (
									<MdOutlineCheckBoxOutlineBlank
										size={20}
										className={styles.checkboxIcon}
									/>
								)}
							</button>
							<input
								min={0}
								className={styles.numberInputCheckbox}
								value={minTimeBeforeSchedule}
								type='number'
								placeholder='4'
								onChange={(e) => setMinTimeBeforeSchedule(e.target.value)}
							/>
							<span>horas</span>
						</div>
						<button
							onClick={() => handleSaveScheduleGapSettings()}
							className={styles.saveButton}
						>
							Guardar
						</button>
					</div>
				</div>
				<div className={styles.container}>
				
					<div
						id='add-calendar'
						style={{ padding: '30px 20px' }}
						className={styles.content}
					>
						<b className={styles.title}>Crear un calendario</b>
						<CustomInput
							title={'Nombre'}
							backProp={'calendarName'}
							updateCalendarProperty={updateCalendarProperty}
							state={newCalendarName}
							setState={setNewCalendarName}
						/>
						<CustomInput
							textArea={true}
							title={'Descripción'}
							backProp={'description'}
							updateCalendarProperty={updateCalendarProperty}
							state={newCalendarDescription}
							setState={setNewCalendarDescription}
						/>
						<CustomDropDown
							title='Zona horaria'
							placeholder='Selecciona una zona horaria'
							options={timezones}
							backProp={'timezone'}
							selectedOption={newCalendarSelectedTimeZone}
							setSelectedOption={setNewCalendarSelectedTimeZone}
						/>

						<CustomInput
							title={'Propietario'}
							readOnly={true}
							state={selectedCalendarData.owner || user.user}
						/>
						<button
							onClick={() => handleCreateCalendar()}
							className={styles.customButtonOutlined}
						>
							Crear calendario
						</button>
					</div>
				</div>
				<div className={styles.container}>
					<div id='settings' className={styles.content}>
						<b className={styles.title}>Configuración de Calendar</b>
						<CustomInput
							title={'Nombre'}
							backProp={'calendarName'}
							updateCalendarProperty={updateCalendarProperty}
							state={calendarName}
							setState={setCalendarName}
						/>
						<CustomInput
							textArea={true}
							title={'Descripción'}
							backProp={'description'}
							updateCalendarProperty={updateCalendarProperty}
							state={description}
							setState={setDescription}
						/>
						<CustomDropDown
							title='Zona horaria'
							placeholder='Selecciona una zona horaria'
							options={timezones}
							backProp={'timezone'}
							updateCalendarProperty={updateCalendarProperty}
							selectedOption={selectedTimeZone}
							setSelectedOption={setSelectedTimeZone}
						/>

						<CustomInput
							title={'Propietario'}
							readOnly={true}
							state={selectedCalendarData.owner || user.user}
						/>
						<button
							onClick={() => handleUpdateActualCalendar()}
							className={styles.customButton}
						>
							Actualizar calendario
						</button>
					</div>
					<div id='access' className={styles.content}>
						<b className={styles.title}>Permisos de accesos de eventos</b>
						<CheckboxAndText
							text={'Compartir públicamente'}
							state={shareWithEveryOne}
							backProp={'publicSharing'}
							updateCalendarProperty={updateCalendarProperty}
							setState={setShareWithEveryOne}
						/>
						<CheckboxAndText
							text={'Compartir con FacturaGPT'}
							state={shareWithAythen}
							backProp={'shareWithAythen'}
							updateCalendarProperty={updateCalendarProperty}
							setState={setShareWithAythen}
						/>
						<CheckboxAndText
							text={
								'Mostrar la información del calendario en otras aplicaciones de FacturaGPT limitado por los permisos de acceso al calendario'
							}
							backProp={'showCalendarInfoOnOtherAythenApps'}
							updateCalendarProperty={updateCalendarProperty}
							state={showCalendarDataInOtherAythenApps}
							setState={setShowCalendarDataInOtherAythenApps}
						/>
						<button className={`${styles.button} ${styles.active}`}>
							Crear enlace para compartir
						</button>
						<p className={styles.small}>
							{`Más información sobre `}
							<a style={{ cursor: 'pointer', userSelect: 'none' }}>
								como compartir tu calendario
							</a>
						</p>
					</div>

					<div id='share' className={styles.content}>
						<b className={styles.title}>Compartir con personas o grupos</b>
						<ShareCalendar
							searchPeople={searchPeople}
							setSearchPeople={setSearchPeople}
							showPeoplePopUp={showPeoplePopUp}
							setShowPeoplePopUp={setShowPeoplePopUp}
						/>
	
						<p className={styles.small}>
							Tu organización puede limitar cómo puedes compartir tu calendario
							fuera de ella. Consulta más información sobre cómo compartir tu
							calendario con alguien.
						</p>
					</div>
					<div id='event-notification' className={styles.content}>
						<b className={styles.title}>Notificaciones de eventos</b>
						<p className={styles.small}>
							Recibe notificaciones de los eventos de este calendario
						</p>
						<ul className={styles.notification}>
							{notifications.map((notification) => (
								<li key={notification.id} className={styles.notificationLi}>
									<NormalDropdown
										selectedOption={notification.type}
										setSelectedOption={(value) =>
											updateNotification(notification.id, 'type', value)
										}
										options={['Notificación']}
									/>
									<input
										className={styles.numberInputCheckbox}
										value={notification.timeValue}
										type='number'
										min={0}
										placeholder='10'
										onChange={(e) =>
											updateNotification(
												notification.id,
												'timeValue',
												e.target.value
											)
										}
									/>
									<NormalDropdown
										selectedOption={notification.timeType}
										setSelectedOption={(value) =>
											updateNotification(notification.id, 'timeType', value)
										}
										options={['minutos', 'horas', 'días']}
									/>
									<IoMdClose
										size={18}
										color={'#666'}
										className={styles.removeIcon}
										onClick={() => removeNotification(notification.id)}
									/>
								</li>
							))}
						</ul>
						<button
							className={`${styles.button} ${styles.active}`}
							onClick={addNotification}
						>
							<div className={styles.mainColorIcon}>
								<FiPlus />
							</div>
							Añadir una notificación
						</button>
					</div>
					<div id='event-notification' className={styles.content}>
						<b className={styles.title}>
							Notificaciones de eventos de todo el día
						</b>
						<CheckboxAndText
							text={
								'Recibe notificaciones de los eventos de todo el día de este calendario'
							}
							backProp={'dailyEventsNotification'}
							updateCalendarProperty={updateCalendarProperty}
							state={dailyEventsNotification}
							setState={setDailyEventsNotification}
						/>
						{dailyEventsNotification && (
							<CustomDropDown
								title='Horario de notificación'
								placeholder='Selecciona un horario'
								options={hoursOptions}
								backProp={'dailyEventsNotification'}
								updateCalendarProperty={updateCalendarProperty}
								selectedOption={dailyEventsNotification}
								setSelectedOption={setDailyEventsNotification}
							/>
						)}
					</div>
					<div id='event-more' className={styles.content}>
						<b className={styles.title}>Otras notificaciones</b>
						<div>
							<p className={styles.text}>
								Recibe notificaciones por correo electrónico cuando se hagan
								cambios en este calendario.
							</p>
						</div>
						<ul className={styles.events}>
							<li>
								<div>
									<b>Nuevos eventos</b>
									<p>Se añade un evento a este calendario</p>
								</div>
								<button
									onClick={() => {
										setCalendarNotifications((prev) => {
											const actualValues = { ...prev }
											actualValues.newEvents = !actualValues.newEvents
											dispatch(
												updateCalendar({
													userId: user.id,
													calendarId: selectedCalendar,
													toUpdate: { ['calendarNotifications']: actualValues },
												})
											).finally(() => handleShowToast())
											return actualValues
										})
									}}
									className={`${styles.submitButton} ${calendarNotifications.newEvents ? styles.sent : ''}`}
								>
									<span className={styles.text}>Enviar</span>
									<span className={styles.icon}>
										<FaCircleCheck size={16} color={`var(--f5-background)`} />
									</span>
								</button>
							</li>
							<li>
								<div>
									<b>Eventos modificados</b>
									<p>Un evento de este calendario cambia</p>
								</div>
								<button
									onClick={() => {
										setCalendarNotifications((prev) => {
											const actualValues = { ...prev }
											actualValues.modifiedEvents = !actualValues.modifiedEvents
											dispatch(
												updateCalendar({
													userId: user.id,
													calendarId: selectedCalendar,
													toUpdate: { ['calendarNotifications']: actualValues },
												})
											).finally(() => handleShowToast())
											return actualValues
										})
									}}
									className={`${styles.submitButton} ${calendarNotifications.modifiedEvents ? styles.sent : ''}`}
								>
									<span className={styles.text}>Enviar</span>
									<span className={styles.icon}>
										<FaCircleCheck size={16} color={`var(--f5-background)`} />
									</span>
								</button>
							</li>
							<li>
								<div>
									<b>Eventos cancelados</b>
									<p>Se cancela un evento de este calendario</p>
								</div>
								<button
									onClick={() => {
										setCalendarNotifications((prev) => {
											const actualValues = { ...prev }
											actualValues.canceledEvents = !actualValues.canceledEvents
											dispatch(
												updateCalendar({
													userId: user.id,
													calendarId: selectedCalendar,
													toUpdate: { ['calendarNotifications']: actualValues },
												})
											).finally(() => handleShowToast())
											return actualValues
										})
									}}
									className={`${styles.submitButton} ${calendarNotifications.canceledEvents ? styles.sent : ''}`}
								>
									<span className={styles.text}>Enviar</span>
									<span className={styles.icon}>
										<FaCircleCheck size={16} color={`var(--f5-background)`} />
									</span>
								</button>
							</li>
							<li>
								<div>
									<b>Respuesta a eventos</b>
									<p>Los invitados responden a un evento de este calendario</p>
								</div>
								<button
									onClick={() => {
										setCalendarNotifications((prev) => {
											const actualValues = { ...prev }
											actualValues.invitationsAnswers =
												!actualValues.invitationsAnswers
											dispatch(
												updateCalendar({
													userId: user.id,
													calendarId: selectedCalendar,
													toUpdate: { ['calendarNotifications']: actualValues },
												})
											).finally(() => handleShowToast())
											return actualValues
										})
									}}
									className={`${styles.submitButton} ${calendarNotifications.invitationsAnswers ? styles.sent : ''}`}
								>
									<span className={styles.text}>Enviar</span>
									<span className={styles.icon}>
										<FaCircleCheck size={16} color={`var(--f5-background)`} />
									</span>
								</button>
							</li>
							<li>
								<div>
									<b>Agenda diaria</b>
									<p>
										Recibe un correo electronico diario con la agenda de este
										calendario
									</p>
								</div>
								<button
									onClick={() =>
										setCalendarNotifications((prev) => {
											const actualValues = { ...prev }
											actualValues.dailySchedule = !actualValues.dailySchedule
											return actualValues
										})
									}
									className={`${styles.submitButton} ${calendarNotifications.dailySchedule ? styles.sent : ''}`}
								>
									<span className={styles.text}>Enviar</span>
									<span className={styles.icon}>
										<FaCircleCheck size={16} color={`var(--f5-background)`} />
									</span>
								</button>
							</li>
						</ul>
					</div>

					<div id='meet' className={styles.content}>
						<b className={styles.title}>Calendarios de citas</b>
						<p className={styles.subtitle}>
							Consulta una vista previa de los nuevos horarios de citas, que
							sustituirán a las <a>horas disponibles</a>. Con los horarios de
							citas, podrás compartir una página de reserva con la que los
							usuarios podrán reservar citas contigo fácilmente.
						</p>
						<CheckboxAndText
							text={'Crear calendarios de citas en vez de horas disponibles.'}
							state={appointmentsCalendarInsteadOfAvailableHours}
							setState={setAppointmentsCalendarInsteadOfAvailableHours}
							backProp={'createAppointmentsCalendarInsteadOfAvailableHours'}
							updateCalendarProperty={updateCalendarProperty}
						/>
						<p className={styles.small}>
							{`Las horas disponibles que tengas o que ya tengas reservadas no
							cambiarán. `}
							<a style={{ cursor: 'pointer', userSelect: 'none' }}>
								Más información sobre cómo usar los nuevos horarios de citas en
								vez de las horas disponibles
							</a>
						</p>
					</div>

					<div id='from-url' className={styles.content}>
						<b className={styles.title}>Desde URL</b>
						<CheckboxAndText
							text={'Hacer el calendario accesible públicamente'}
							state={calendarAsPublic}
							backProp={'publicCalendar'}
							updateCalendarProperty={updateCalendarProperty}
							setState={setCalendarAsPublic}
						/>
						<p className={styles.small}>
							Puedes añadir un calendario con el formato de iCal por su
							dirección
						</p>
						<button className={`${styles.button} ${styles.inactive}`}>
							Añadir calendario
						</button>
						{calendarAsPublic && (
							<div 
							className={styles.calendarAsPublicContent}
							>
								<CustomInput
									fullWidth={true}
									title={'ID del calendario'}
									readOnly={true}
									state={selectedCalendarData.shareId || ''}
								/>
								<CustomInput
									fullWidth={true}
									title={'URL pública de este calendario'}
									readOnly={true}
									state={
										selectedCalendarData.shareId
											? `http://aythen.com/es/app/calendar/watchCalendar/${selectedCalendarData.shareId}`
											: 'Crear URL pública'
									}
								/>
								<p className={styles.small}>
									Usa esta URL para acceder a este calendario desde un navegador
									web.
								</p>
								<div>
									<b>Insertar código</b>
								</div>
								<div>
									<p>
										Usa este código para insertar el calendario en una página
										web.
									</p>
									<p className={styles.small}>
										Puedes personalizar el código o insertar varios calendarios.
									</p>
									<button
										onClick={() => navigate('/admin/calendar/preview')}
										style={{ marginTop: '5px' }}
										className={styles.saveButton}
									>
										Personalizar
									</button>
								</div>
							</div>
						)}
					</div>

					<div id='delete' className={styles.content}>
						<b className={styles.title}>Eliminar calendario</b>
						<p className={styles.small}>
							{`Se eliminarán todos los eventos de este calendario. Si algún
							evento tiene invitados, también se quitará de sus calendarios. `}
							<a style={{ cursor: 'pointer', userSelect: 'none' }}>
								Más información sobre cómo quitar calendarios
							</a>
						</p>
						<CustomDropDown
							title='Eliminar calendario'
							placeholder='Selecciona un calendario'
							options={userCalendars.map((calendar) => calendar.calendarName)}
							selectedOption={calendarToDelete}
							setSelectedOption={setCalendarToDelete}
						/>
						<button
							onClick={() => calendarToDelete && handleDeleteCalendarEvents()}
							className={`${styles.button} ${calendarToDelete ? styles.active : styles.inactive}`}
						>
							Eliminar
						</button>
					</div>
				</div>
				<div className={styles.container}>
					<div id='import' className={styles.content}>
						<b className={styles.title}>Importar</b>
						<input
							type='file'
							accept='.json'
							style={{ display: 'none' }}
							id='fileInput'
							onChange={handleFileUpload}
						/>
						<div
							className={`${styles.button} ${styles.files}`}
							onClick={() => document.getElementById('fileInput').click()}
						>
							<div className={styles.downloadIcon}>
								<MdOutlineFileUpload size={20} />
							</div>
							<p>
								{calendarEventsToImport
									? 'Archivo seleccionado'
									: 'Seleccionar un archivo del ordenador'}
							</p>
						</div>
						<b className={styles.subtitle}>Añadir al calendario</b>
						<CustomDropDown
							title='Añadir al calendario'
							placeholder='Selecciona un calendario'
							options={userCalendars.map((calendar) => calendar.calendarName)}
							selectedOption={calendarToMergeWith}
							setSelectedOption={setCalendarToMergeWith}
						/>
						<p className={styles.small}>
							Se añadira la información de eventos del calendario importado al
							calendario seleccionado
						</p>
						<button
							onClick={() =>
								calendarEventsToImport &&
								calendarToMergeWith &&
								handleImportCalendar()
							}
							className={`${styles.button} ${calendarEventsToImport && calendarToMergeWith ? styles.active : styles.inactive}`}
						>
							Importar
						</button>
					</div>

					<div id='export' className={styles.content}>
						<b className={styles.title}>Exportar</b>
						<ul className={styles.calendarsList}>
							{userCalendars.map((calendar, index) => (
								<li
									onClick={() => {
										if (
											!selectedCalendarsToExport.some(
												(cal) => cal.id === calendar.id
											)
										) {
											setSelectedCalendarsToExport((prev) => [
												...prev,
												calendar,
											])
										} else {
											setSelectedCalendarsToExport((prev) =>
												[...prev].filter((cal) => cal.id !== calendar.id)
											)
										}
									}}
									style={{ cursor: 'pointer', width: '100%' }}
									key={index}
								>
									{selectedCalendarsToExport.some(
										(cal) => cal.id === calendar.id
									) ? (
										<MdCheckBox
											style={{ cursor: 'pointer' }}
											size={20}
											className={styles.calendarCheckbox}
										/>
									) : (
										<MdCheckBoxOutlineBlank
											style={{ cursor: 'pointer' }}
											size={20}
											className={styles.calendarCheckbox}
										/>
									)}
									<span>{calendar.calendarName}</span>
								</li>
							))}
						</ul>
						<p className={styles.small}>
							Permite descargar en un solo archivo todos los calendarios que
							puedas ver y modificar
						</p>
						<button
							onClick={() =>
								selectedCalendarsToExport.length > 0 && handleExportCalendars()
							}
							className={`${styles.button} ${selectedCalendarsToExport.length > 0 ? styles.active : styles.inactive}`}
						>
							Exportar
						</button>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Settings

const ModalLocation = () => {
	return (
		<div>
			<div className={styles.content}>
				<p>Otra oficina</p>
				<p>Añade ubicación</p>
				<p>0/ 512</p>
			</div>
			<div className={styles.content}>
				<button>Cancelar</button>
				<button>Añadir</button>
			</div>
		</div>
	)
}

const ModalDelete = () => {
	return (
		<div className={styles.content}>
			<p>
				Estás a punto de eliminar todos los eventos de FacturaGPT Company de forma
				permanente. Esta acción no se puede deshacer. ¿Quieres continuar?
			</p>
			<button>Cancelar</button>
			<button>Eliminar definitivamente</button>
		</div>
	)
}
